module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('figure', {
    staticClass: "fighaut",
    attrs: {
      "id": "P1"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "",
      "src": "images/P1.jpg"
    }
  })])]), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("INTRODUCTION")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("I choose to enjoy the glory")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("of the everlasting, ever present One,")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("To sit and listen")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("to what delights God’s heart.")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("I choose to breathe in the wonder")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("of eternal love,")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("And dance to the rhythm of eternal breath,")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("listening to the whispers")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("calling me to slow down and take notice.")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("I choose to absorb the beauty")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("of the divine presence,")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("to delight in the Creator of all things")])]), _c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("and relish the delight God takes in me.")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Can you imagine a God who dances with shouts of joy, laughs when you laugh, loves to play, enjoys life, and invites us to join the fun? I couldn’t until recently.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I grew up with a serious, workaholic type of God who chastised me for not keeping busy twenty-four hours a day, seven days a week. Even when I realized this was not what God was really like, it was hard to change. I felt guilty when I slowed down, took a break, or just went out and had fun. This following Jesus is serious business after all. Like the disciples who tried to chase away the children that came to Jesus, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("I couldn’t be bothered with frivolous practices where play and laughter disrupted my routines. Gasping in awe and wonder at an opening blossom or a slow-moving caterpillar seemed like a waste of time.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Then one year my early Lenten readings included the verse “Unless you become like children you cannot enter the kingdom of God.” These words riveted my attention.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The next day I came across an article by Dr. Stuart Brown, who has dedicated his life to the study of play. We all need play, he believes. It connects us to others, sharpens our minds, and may even help us avoid degenerative diseases like Alzheimer’s. “What you begin to see when there’s major play deprivation in an otherwise competent adult is that they’re not much fun to be around,” he says. “You begin to see that the perseverance and joy in work is lessened and that life is much more laborious.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-003",
      "id": "ap_ntf-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Seek the kingdom of God above all else,” Jesus repeatedly tells his disciples, and this has been the passion of my life. How could play, fun, and the delights of childhood prepare us for this? There was rarely anything childlike about my spirituality or that of my friends and colleagues.")]), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-001"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fighaut",
    attrs: {
      "id": "carre30"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/carre.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Have we dismissed the child within us and lost the joy of life and the delight in God that emerges when we play and laugh and marvel at the world around us?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Let the little children come to me; do not stop them; for it is to such as these that the kingdom of God belongs” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Mark+10%3A14&version=NRSV",
      "target": "_blank"
    }
  }, [_vm._v("Mark 10:14")]), _vm._v(" NRSV). Have we dismissed the child within us and lost the joy of life and the delight in God that emerges when we play and laugh and marvel at the world around us?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Ask kids what they don’t like about adults and they say we don’t have enough fun. We don’t enjoy life enough and we don’t enjoy God enough either. To enjoy God more fully and recognize God’s delight in us, we must "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("rediscover the world of childhood and unleash the inner child hidden deep in our souls.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I posted this question on Facebook: What are the childlike characteristics that make us fit for the kingdom? I was amazed at the enthusiastic response:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("playfulness")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("awe and wonder")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("imagination")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("curiosity")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("love of nature")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("compassion")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("unconditional trust")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These all emerged as childlike qualities that my friends thought were important preparation for the new world Jesus came to introduce us to. Of course, others pointed out that children can also be aggravating, bothersome, and intrusive at the most inopportune moments. Yet as Judy Brown Hull suggests in her insightful book "), _c('i', [_vm._v("When You Receive a Child: Reflections on Luke 9:46-48")]), _vm._v(", even these can be gifts from God that reflect something of the kingdom and the intrusiveness of Jesus as he enters our lives. “Unselfconscious, bothersome, unpredictable—children have another similarity to Jesus: while they are fully human—they do not fit tidily into the totally adult world any better than Jesus did.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-004",
      "id": "ap_ntf-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" She provocatively goes on to suggest that this might be because Jesus’ reality is closer to that of a child than an adult.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Having listed childlike characteristics that make us fit for the kingdom, responders often commented, “I’ve never thought about this before.” Delighting in fun and laughter as a pathway to enjoying God is something most of us never consider.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("We suffer from play deprivation, nature deficit disorder, awe depletion, compassion fatigue, imagination suppression, and more. As a result I think we suffer from God deprivation too.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I am increasingly convinced that rediscovering our inner child is essential for our spiritual health. It has become an important and delightful journey for me and is the central theme of "), _c('i', [_vm._v("The Gift of Wonder")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Awe and wonder, imagination and curiosity connect us to the God who is present in every moment and everything in a way that nothing else can. They enrich our contemplative core and expand our horizons to explore new aspects of our world and our God. Believing in a God who loves to plant gardens with dirty hands and make mud pies to put on the eyes of the blind, or who does happy dances and sings with joy over all of humanity and in fact all of creation has revolutionized my faith.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Ironically, my life has been filled with joy and satisfaction, though I have rarely linked this to my spiritual practices. My childhood in Australia was filled with fun family summer caravan adventures. I studied medicine and delighted in my years as a family physician in New Zealand. In 1981 I joined a fledgling part of Youth with a Mission called Mercy Ships and enjoyed the privilege of establishing a hospital on board the MV "), _c('i', [_vm._v("Anastasis")]), _vm._v(", to perform cleft lip and palate and eye surgeries. Over the twelve years I spent on board, I facilitated surgical outreaches in Mexico, the Caribbean, and Africa. I worked with refugees on the Thai-Cambodian border, in Haiti, and in Ivory Coast. I saw thousands of lives transformed and had the intense joy and satisfaction of knowing my life had made a difference.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After I left the ship, my life took another direction, but I still find intense joy in what I accomplish as an author, speaker, and blogger. Helping people create spiritual pathways that lead them toward a deeper relationship with God is a delight.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My faithful companion over the last twenty-six years of this journey has been my husband, futurist and author Tom Sine. He is constantly "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("researching how our world is changing and how we need to change to be more creative in helping people imagine new possibilities for their lives, churches, and neighborhoods. He loves to cook, walk our dog, and garden with me, and has enthusiastically supported my writing. His insightful and often playful responses to my sharing of new practices have kept me on track throughout.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Tom and I live in a small intentional community in Seattle called the Mustard Seed House. We enjoy a weekly meal and check-in times, which have often provided space for experimenting with the practices I share in this book. We also love to share food from our garden with friends and sometimes strangers from all over the world.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("I CHOOSE JOY")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("My understanding of spiritual disciplines has changed dramatically over the last few years. It continues to change as I delve into the characteristics of childlikeness and rediscover the joy of play and curiosity and awe.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It all began when I asked people, “What makes you feel close to God?” They responded with stories of sitting by the sea, playing with kids, turning the compost pile, washing the dishes, and walking in the local park. Even taking a shower got a mention. Hardly anyone talked about church or Bible study. Most people connect to God through nature, interaction with children, around the dinner table, or in their daily activities. However, they rarely identify these as spiritual practices.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These revelations started me on a journey. Encouraged by contemplative friends, I dived into the liturgical calendar and explored a range of ancient practices like lectio divina and labyrinth walking, which greatly enriched my faith and drew me closer to God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-005",
      "id": "ap_ntf-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" I wrote breathing prayers and liturgies to enhance my personal intimacy with the eternal One. A new depth of delight in God began to emerge. Some of these ideas I shared in my previous book "), _c('i', [_vm._v("Return to Our Senses: Reimagining How We Pray")]), _vm._v(", but my horizons continued to expand.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("When I started asking “What do you enjoy about God?” and “What about you gives God joy?” I ventured out beyond the bounds of these ancient but traditional practices to explore creative approaches to prayer, like rock painting and doodling, that stirred my imagination and connected my everyday activities to my relationship with my Creator. I planted prayer gardens and sketched colorful designs as meditative exercises. I had fun with my spiritual practices and invited others to join me on the journey. My inner child was stirring and my soul came alive in ways I never anticipated. I watched friends bubble over with this same enthusiasm for God while engaged in creative activities unlike the traditional practices we grew up with.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The more these practices increased my love for God, the more I wanted to understand what brings joy to God’s heart. I incorporated my questions, What do you enjoy about God? and What are you choosing that gives God joy? into my Sunday devotions, where I reflect back on my week and realized that now I needed to reshape my spiritual practices in response to these prompts.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Much to my surprise, many people I talk with are hungry for answers to these same questions yet rarely ask them. Some confess they are not sure anything gives God joy. They see God as a distant, judgmental figure constantly accusing and punishing them for their mistakes. To believe that God is full of joy and enjoys both them and creation is a totally foreign concept. Yet it makes them light up with delight when they begin to understand.")]), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-002"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fighaut",
    attrs: {
      "id": "carre31"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/carre.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What if finding joy in the divine presence is the greatest way to glorify God and become who God created us to be?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So much of what we learn about spirituality is negative. We believe more in a God of judgment and condemnation than of love, joy, and delight. Following God is about adhering to a long list of things we don’t do—no smoking, drinking, dancing, wearing jewelry, or sex before marriage. Alternatively, it is a list of rules that encourage us to color inside the lines and live inside our religious boxes. We live in dread of displeasing God or taking a wrong step that means we can "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("never find God’s best for our lives. That God delights in who we are and what we do now is a wonderful but startling revelation for many of us.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Psalm 18:19 tells us we are rescued because God delights in us, and Psalm 147:11 affirms that the eternal One takes pleasure in those who put their hope in God’s unfailing love. Even the Westminster Shorter Catechism states that the chief purpose of humanity is “to glorify God and to "), _c('i', [_vm._v("enjoy him forever")]), _vm._v(".”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What if finding joy in the divine presence is the greatest way to glorify God and become who God created us to be? What if becoming like a child is the pathway, and what if we reshape our spiritual practices with this in mind?")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("THE SHAPE OF THIS BOOK")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What are the childlike characteristics that bring God joy and make us fit for the kingdom?"), _c('i', [_vm._v(" i")]), _vm._v("s the question that shapes this book. Asking it in my own life opened hidden doorways for me, a little like Lucy in C. S. Lewis’s classic "), _c('i', [_vm._v("The Lion, the Witch and the Wardrobe")]), _vm._v(". She steps through the wardrobe into the magical world of Narnia, where animals speak and creation dances. She gazes on it with awe and wonder and a delight, which grew as she met its inhabitants and burst into life as the great king Aslan approached.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My own magical doorway took me into a mystical world of awe and wonder walks, joy-spot sightings, nostalgia trips, compassion games, and playdate adventures. I relearned the arts of gratitude and curiosity, as well as the delight of living in the present rather than the past or future. Here too creation speaks, relationships are strengthened, and my love for the God revealed in Jesus Christ has taken on new vibrancy and depth, which I hope to share with you.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("This book will teach you to pay attention to childlike characteristics that shape us into kingdom people. Each chapter addresses one characteristic we need to embrace:")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("delight in God")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("playfulness")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("sharing our stories")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("imagination")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("curiosity")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("awe and wonder")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("love of nature")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("the ability to live in the present")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("gratitude")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("compassion")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("hospitality")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("the intrigue of looking with fresh eyes")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("trust")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("The Gift of Wonder ")]), _vm._v("explores how to reshape our spiritual practices so that giving God joy and drawing closer to our loving Creator becomes their primary purpose. The last chapter is on trust. Here we will braid together the lessons from previous chapters into a strong, unbreakable cord that revitalizes our faith.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Chapters include stories of others who follow this path. I am not the only one exploring new and meaningful approaches to spiritual disciplines or experimenting with creative ways to bring joy to God as I express faith. Nor am I the only one relishing a growing delight in God as a result. Many people I know are creating fresh ways to pray, imaginatively reshaping and adapting time-honored liturgical practices to their current lifestyles and making them uniquely their own. They "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("are hungry for vital faith but bored with traditional practices. They are exploring experiential approaches to spirituality that integrate everyday activities into their faith. In the process they, like me, are discovering the delights of childlike faith that draws us into God’s kingdom.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Each chapter concludes with a creative exercise that invites you to awaken your inner child. These exercises encourage you to apply your newfound knowledge to your faith as you reflect on what you have read. Some draw on fun-filled childhood activities like coloring, doodling, and reading children’s books, which reduce our stress and free us to enter more fully into our enjoyment of God. Others adapt practices that have existed in the church for centuries, like contemplation and labyrinth walking. Still others are based on totally new ideas of how to practice our faith and draw close to our delightful God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Build a toolkit. Start by gathering")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("a notebook or journal")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("some crayons")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("colored pens, pencils, or paints")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("a coloring book")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("your favorite children’s book")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("your camera (or phone) if you enjoy taking photos")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("your favorite musical instrument")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("your Bible")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This toolkit incorporates elements that appeal to most learning styles. What else should you add? Do you already use creative tools that cater to your learning style? Are you a visual learner inspired by images, maps, or graphic designs? You might like to add photos. Perhaps you are an auditory learner stirred by music, podcasts, lectures, and listening situations. You might want to include a drum or singing bowl. If you learn best through words, loving to take notes and read, a "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("journal and some of your favorite books might be your primary tools. Tactile learners who love hands-on projects and figure things out by putting them together might like to add whittling tools, a puzzle, or your knitting.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("JOURNEY WITH OTHERS")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is not a journey you want to attempt alone. Recruit a group of fellow searchers as companions. Plan weekly meetings where you can give each other permission to have some fun, become like children, and explore the creative exercises together.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Parker Palmer in "), _c('i', [_vm._v("A Hidden Wholeness")]), _vm._v(" comments, “To understand true self—which knows who we are in our inwardness and whose we are in our larger world—we need both the interior intimacy that comes with solitude and the otherness that comes with community. . . . Together they make us whole, like breathing in and breathing out.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-006",
      "id": "ap_ntf-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Part of what I love about community is the way we spark each others’ creativity and imagination. Creativity gives birth to more creativity. Shared awe and wonder grow until they fill the horizon. Sharing our stories ignites creativity, sparking something new within us "), _c('i', [_vm._v("and")]), _vm._v(" others. Like a wildfire spread by the wind, creativity jumps from place to place, bursting into flame, burning away the old to make way for the new. “And in the sharing we experience the joy a second time.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-007",
      "id": "ap_ntf-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Each creative exercise provides special instructions for group interaction. Reflect on your responses to the exercises at the end of the chapters. Create new practices together. Laugh, eat, and have fun together.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So let us choose the joy of unleashing our inner child today. Let us begin the adventure of reshaping our spiritual practices to delight in God and appreciate the delight that God takes in us.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0